import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "EquipmentListPage" */
	'pages/intervention/Equipment/EquipmentListPage'));

export default [{ component, exact: true, path: '/equipments' }];